import React, { Component } from "react";

class ClientCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      banner: {
        id: this.props.id,
        imgUrl: this.props.banner.imgUrl,
        redirectUrl: this.props.banner.redirectUrl,
        imgTitle: this.props.banner.imgTitle,
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }

  handleChange(e) {
    let { name, value } = e.target;
    let banner = { ...this.state.banner };
    banner[name] = value;
    this.setState({
      banner: banner,
    });
  }

  handleUpload(e) {
    let banner = { ...this.state.banner };
    banner[e.target.name] = e.target.files[0];
    this.setState({ banner: banner });
  }

  render() {
    let banner = this.state.banner;
    return (
      <React.Fragment>
        <div className="col-sm-4 mt-2">
          <div
            className="card"
            style={{ border: "2px solid rgba(0,0,0,.125)" }}
          >
            <div className="card-body">
              <h5 className="card-title">Title: {banner.imgTitle}</h5>

              <div className="m-2">
                <img
                  src={banner.imgUrl}
                  title="banner Logo"
                  style={{ width: "100%", height: "120px" }}
                />
              </div>
              <p className="card-text">
                <b>Redirect:</b> {banner.redirectUrl}
              </p>
              <button
                href="#"
                className="btn btn-primary m-0 p-0 px-2 mr-2"
                data-toggle="modal"
                data-target={`#cpe${this.props.id}`}
                // onClick={() => this.props.setCouponId(props.id)}
              >
                Edit
              </button>
              {/* ------------------------------------ Edit banner Modal starts ------------------------------------*/}
              <div
                className="modal fade bd-example-modal-lg"
                id={`cpe${this.props.id}`}
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Edit and Save the details
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <form
                        onSubmit={(e) =>
                          this.props.handleEditSubmit(e, this.state.banner)
                        }
                      >
                        <div className="row mx-4">
                          <div class="form-group col-md-6">
                            <label for="imagetitle">Image Title</label>
                            <input
                              name="imgTitle"
                              type="text"
                              id="imagetitle"
                              className="form-control"
                              value={banner.imgTitle}
                              onChange={this.handleChange}
                              placeholder="Enter Image Title"
                              required
                            />
                          </div>
                          <div class="form-group col-md-6">
                            <label for="imageurlbrand">Upload Image</label>
                            <input
                              name="image"
                              type="file"
                              id="imageurlbrand"
                              className="form-control"
                              onChange={this.handleUpload}
                              accept=".png,.jpeg, .jpg, .webp"
                            />
                          </div>
                        </div>
                        <div className="row mx-4">
                          <div class="form-group col-md-8">
                            <label for="redirect">Redirect Url</label>
                            <input
                              name="redirectUrl"
                              type="text"
                              id="redirect"
                              className="form-control"
                              placeholder="Enter Redirect Url"
                              onChange={this.handleChange}
                              value={banner.redirectUrl}
                              required
                            />
                          </div>
                          <div className="modal-footer">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              id={banner.id}
                              disabled={this.props.bannerBtnLoading}
                            >
                              {this.props.bannerBtnLoading
                                ? "Saving"
                                : "Save"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* ------------------------------------ Edit banner Modal ends ------------------------------------*/}
              {/* {props.isAdmin ? ( */}
              <button
                href="#"
                className="btn btn-secondary m-0 p-0 px-2"
                data-toggle="modal"
                data-target={`#cpd${this.props.id}`}
              >
                Delete
              </button>
              {/* ) : null} */}

              {/* ------------------------------------ Delete banner Modal starts ------------------------------------*/}
              <div
                className="modal fade"
                id={`cpd${this.props.id}`}
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Irreversible Operation
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to delete <b>{banner.imgTitle}</b>
                      </p>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={(e) =>
                          this.props.handleDeleteBanner(e, banner)
                        }
                        disabled={this.props.deleteBtnLoading}
                      >
                        {this.props.deleteBtnLoading ? "Deleting" : "Delete"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* ------------------------------------ Delete banner Modal ends ------------------------------------*/}
            </div>
          </div>
        </div>
      </React.Fragment>
    ); 
  }
}

export default ClientCard;
